module.exports = __webpack_public_path__ + "static/img/indexbg8.f58e90b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg8.jpg
// module id = GdTM
// module chunks = 1